import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';

import commonStyles from 'styles/common.pcss';
import { formatPriceExtended } from 'utils/formatting';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import {
  getLeasingMonthPayment,
  getLeasingBundleAvailability,
  selectIsBundleActive,
} from 'store/ProductDetails/selectors';
import { Bundle, getBundlesPriceWithoutPromotion } from 'store/ProductDetails/bundles/selectors';

import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

type BundlePriceProps = {
  isMobile: boolean;
  monthPayment: number;
  bundleHasLeasing: boolean;
  priceWithoutPromotion: number;
  bundle: Bundle;
  isBundleActive: boolean;
};

const BundlePrice_ = ({
  isMobile,
  monthPayment,
  bundleHasLeasing,
  priceWithoutPromotion,
  bundle,
  isBundleActive,
}: BundlePriceProps) => (
  <div className={cx(isMobile && 'total-price-wrapper')}>
    {bundle.getDiscount() > 0 && !bundleHasLeasing ?
      <div
        className={cx('bundle-discount', {
          'bundle-discount--mobile': isMobile,
        })}
      >
        {!isBundleActive && !!priceWithoutPromotion && (
          <Text isCrossedOut crossOutColor="scarlet" color="grey60" size="size3">
            {formatPriceExtended(priceWithoutPromotion)}
          </Text>
        )}
      </div>
    : null}
    <div className={cx('bundle-price')} id={isMobile ? 'promoBundle' : 'bundlePrice'}>
      {bundleHasLeasing ?
        <Text size="size2-b">{formatPriceExtended(monthPayment)}</Text>
      : <Text size="size2-b">{formatPriceExtended(bundle.getPrice())}</Text>}
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  isMobile: isScreenBelow800(state),
  monthPayment: getLeasingMonthPayment(state),
  bundleHasLeasing: getLeasingBundleAvailability(state),
  isBundleActive: selectIsBundleActive(state),
  priceWithoutPromotion: getBundlesPriceWithoutPromotion(state),
});

export const BundlePrice = connect(mapStateToProps)(BundlePrice_);
